
export const ArrowRightIcon = () => (
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.495 6.49497C18.7683 6.22161 18.7683 5.77839 18.495 5.50502L14.0402 1.05025C13.7668 0.776884 13.3236 0.776884 13.0503 1.05025C12.7769 1.32362 12.7769 1.76683 13.0503 2.0402L17.01 6L13.0503 9.9598C12.7769 10.2332 12.7769 10.6764 13.0503 10.9497C13.3236 11.2231 13.7668 11.2231 14.0402 10.9497L18.495 6.49497ZM5.77962e-08 6.7L18 6.7L18 5.3L-5.77962e-08 5.3L5.77962e-08 6.7Z" fill="#517FF5"/>
  </svg>
);
